import React from 'react';
import ThemeToggle from './ThemeToggle';

export default function CenterTile({ getArticles, searchArticles, classes, isSearched }) {
    return (
        <div className={`border border-zinc-900 dark:border-zinc-100 dark:text-white h-72 flex flex-col items-center justify-between ${classes}`}>
            <div className="flex flex-row-reverse w-full justify-between">
                <ThemeToggle />
                {isSearched && (
                    <button
                        aria-label="Back"
                        type="button"
                        className="p-3 h-12 w-12 rounded-lg self-end"
                        onClick={getArticles}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 15l-3-3m0 0l3-3m-3 3h8M3 12a9 9 0 1118 0 9 9 0 01-18 0z" />
                        </svg>
                    </button>
                )}
            </div>
            <div onClick={getArticles} className="cursor-pointer">
                <div className="text-3xl font-bold text-center">THE<br />BOARD</div>
            </div>
            <input placeholder="Search"
                onKeyPress={(ev) => {
                    if (ev.key === "Enter") {
                        ev.preventDefault();
                        searchArticles(ev.target.value);
                    }
                }}
                className="bg-transparent border-b border-zinc-900 dark:border-zinc-100 mb-4 outline-none mx-auto w-48 text-lg text-gray-600 dark:text-gray-400 font-semibold">
            </input>
        </div>
    )
}
